window.addEventListener('load', function () {
  const Swiper = window.Swiper;
  const carouselLoop = document.querySelectorAll('.blog-carousel--loop');
  const carouselWatchOverflow = document.querySelectorAll(
    '.blog-carousel--watchOverflow'
  );

  const carouselArgs = {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 20,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    keyboard: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1080: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    },
    navigation: {
      nextEl: '.blog-carousel__arrows .swiper-button-next',
      prevEl: '.blog-carousel__arrows .swiper-button-prev',
    },
    pagination: {
      el: '.blog-carousel .swiper-pagination',
      clickable: true,
    },
  };

  if (0 < carouselLoop.length) {
    let carouselLoopArgs = carouselArgs;
    carouselLoopArgs.centeredSlides = true;
    carouselLoopArgs.loop = true;
    new Swiper('.blog-carousel--loop', carouselLoopArgs);
  }

  if (0 < carouselWatchOverflow.length) {
    let carouselWatchOverflowArgs = carouselArgs;
    carouselWatchOverflowArgs.centerInsufficientSlides = true;
    carouselWatchOverflowArgs.watchOverflow = true;
    new Swiper('.blog-carousel--watchOverflow', carouselWatchOverflowArgs);
  }
});
